// src/pages/FormPage.js
/**
 * FormPage
 * --------
 * Lightweight route component that simply mounts the multi-step
 * <DynamicUserForm/> inside a centred, max-width wrapper.
 *
 * Purpose
 *  • Keeps React-Router wiring separate from form logic.
 *  • Applies page-level sizing / padding (utility classes only).
 *
 * No props, no local state – purely presentational.
 */

import React, { memo } from "react";
import DynamicUserForm from "../components/form/DynamicUserForm";
import { useLocation } from "react-router-dom";
/* ------------------------------------------------------------------ */
/* Main component                                                      */
/* ------------------------------------------------------------------ */
function FormPage() {
  const { state } = useLocation(); // ← { prefill: {...} } | undefined
  return (
    <div className="form-page w-full h-full max-w-lg">
      <DynamicUserForm initialData={state?.prefill} />{" "}
    </div>
  );
}

export default memo(FormPage);
